import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaymentControllerService } from '../api/services';
import * as bootstrap from 'bootstrap';
import { PaymentRequestDto } from '../api';

@Component({
  selector: 'app-push-payment',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './push-payment.component.html',
  styleUrl: './push-payment.component.css'
})
export class PushPaymentComponent {

    formPay:FormGroup;
    textColor='text-success';
    message ='';


    constructor(private formBuilder:FormBuilder,
      private paymentService:PaymentControllerService
    ){
      this.formPay = this.formBuilder.group({
        amount:['',[Validators.required,Validators.min(5)]],
        phone:['',[Validators.required]]
      });

    }
    sendPayment(){
      let form = this.formPay.value;
      let amnt = form.amount?form.amount:0;
      const datepipe: DatePipe = new DatePipe('en-US')
              let formattedDate = datepipe.transform( Date(), 'YYMMddHHmmss');
              let nb = Math.floor(Math.random()*1000000);
              let reqId ='pp-'+formattedDate+'-'+nb;

      let dto:PaymentRequestDto={
        amount: amnt,
        currencyCode:'XOF',
        requestId:reqId,
        receptionMean: form.value,
        push:true
      }
      this.paymentService.initiatePayment(dto).subscribe({
        next:(resp)=>{
          this.message = 'Votre url de paiement '+resp.paymentUrl;
          this.textColor ='text-success';
          this.formPay.reset();
          const elt =document.getElementById('modPushPay');
                               const modAdd = new bootstrap.Modal(elt!!);
                               modAdd.show()
        },
        error:(err)=>{
          this.message =err.error.message;
          const elt =document.getElementById('modErrPay');
                               const modAdd = new bootstrap.Modal(elt!!);
                               modAdd.show()
        }
      }
      );

    }

}
